<template>
  <div class="prices">
    <Header
      :right-sidebar="true"
      :right-sidebar-title="`Абонементы спортзала &quot;${gymName}&quot;`"
    >
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="pricesDisplayableFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="pricesFields"
            :items="prices"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item variant="success" :to="`/gyms/${gymId}/prices/create`">
          Добавить абонемент
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <h1 class="special-title">
      {{ gymName }}
    </h1>
    <Main>
      <b-overlay :show="!loaded">
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          @row-clicked="item => openPrice(item)"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
  </div>
</template>

<script>
import axios from "@/axios";
import Header from "@/components/Layout/Header";
import { displayableFields } from "@/components/Tables/defaultFields";
import { pricesFields } from "@/views/Gyms/Prices/models/pricesTableModel";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import Main from "@/components/Layout/Main";
import { mapGetters } from "vuex";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    Main,
    FieldsPicker,
    SidebarItem,
    SidebarItemsGroup,
    FiltersGroup,
    Header
  },
  mixins: [pageTitleMixin],
  props: {
    gymId: {
      type: Number,
      required: true
    }
  },
  data() {
    let pricesDisplayableFields = displayableFields(pricesFields);
    return {
      pricesFields,
      pricesDisplayableFields,
      filteredItems: [],
      prices: [],
      pickedFields: [...pricesDisplayableFields],
      pricesLoaded: false
    };
  },
  computed: {
    ...mapGetters("gyms", {
      gyms: "gyms",
      gymsLoaded: "loaded"
    }),
    gym: ({ gyms, gymId }) => gyms.find(({ id }) => Number(id) === gymId),
    gymName: ({ gym }) => gym?.name,
    loaded: ({ gymsLoaded, pricesLoaded }) => gymsLoaded && pricesLoaded,
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    openPrice({ id }) {
      this.$router.push(`/gyms/${this.gymId}/prices/${id}`);
    }
  },
  async created() {
    this.prices = (
      await axios.get(`/gyms/${this.gymId}/prices`)
    ).data.gym_prices;
    this.pricesLoaded = true;
  }
};
</script>
